import React from 'react';
import { useTranslation } from 'react-i18next';
import { Toaster } from 'react-hot-toast';

/**
 * Task Boards and Workspaces confirm with react-hot-toast, but the app mounts no global <Toaster/>, so their
 * toasts never rendered. Mounted once per Project Management route, styled like the Payroll Controls previews.
 */
export default function ProjectToaster() {
  const { i18n } = useTranslation();
  return (
    <Toaster
      position={i18n.dir() === 'rtl' ? 'bottom-left' : 'bottom-right'}
      toastOptions={{
        style: {
          background: 'var(--color-popover)',
          color: 'var(--color-popover-foreground)',
          border: '1px solid var(--color-border)',
          fontSize: '0.875rem',
          maxWidth: '28rem',
        },
      }}
    />
  );
}
